import { navbar } from "../elements";
import {
  asyncForEach,
  make_elements_tabbable,
  make_elements_untabbable,
  wait,
} from "../helpers";

export function useMegaNav() {
  if (!navbar) return;

  function megaNav() {
    const sub_wraps = navbar.querySelectorAll(".menu-item-has-children");

    function getSubWrapElements(sub_wrap) {
      const btn = sub_wrap.querySelector(".navbar__sub-toggle");
      const back_btn = sub_wrap.querySelector(".navbar__back-btn");
      const sub_menu = sub_wrap.querySelector(".navbar__sub-menu");
      const sub_menu_items = sub_menu.querySelectorAll(".navbar__menu-item");
      const sub_nav_links = sub_menu.querySelectorAll(".navbar__link");

      const sub_focusable_elements = [back_btn, ...sub_nav_links];

      return {
        btn,
        back_btn,
        sub_menu,
        sub_menu_items,
        sub_nav_links,
        sub_focusable_elements,
      };
    }

    function closeSubNav(sub_wrap) {
      const { btn, sub_menu, sub_menu_items, sub_focusable_elements } =
        getSubWrapElements(sub_wrap);

      btn.setAttribute("aria-expanded", "false");
      sub_menu.setAttribute("aria-expanded", "false");
      sub_wrap.classList.remove("open");
      make_elements_tabbable(sub_focusable_elements);
      sub_menu_items.forEach((item) => item.classList.add("out"));
    }

    function closeAllSubNavs() {
      sub_wraps.forEach((sub) => {
        closeSubNav(sub);
      });
    }

    closeAllSubNavs();

    function openSubNav(sub_wrap) {
      closeAllSubNavs();

      const { btn, sub_menu, sub_menu_items, sub_focusable_elements } =
        getSubWrapElements(sub_wrap);

      btn.setAttribute("aria-expanded", "true");
      sub_menu.setAttribute("aria-expanded", "true");
      sub_wrap.classList.add("open");
      make_elements_untabbable(sub_focusable_elements);
      asyncForEach(sub_menu_items, async (item) => {
        await wait(100);
        item.classList.remove("out");
      });
    }

    sub_wraps.forEach((sub_wrap) => {
      const { btn, back_btn } = getSubWrapElements(sub_wrap);

      btn &&
        btn.addEventListener("click", () => {
          if (btn.getAttribute("aria-expanded") === "false") {
            openSubNav(sub_wrap);
          } else {
            closeSubNav(sub_wrap);
          }
        });

      back_btn &&
        back_btn.addEventListener("click", () => {
          closeSubNav(sub_wrap);
          btn.focus();
        });
    });
  }

  megaNav();
}
